import gql from 'graphql-tag';

export const LISTING_PREVIEW_FRAGMENT = gql`
    fragment LISTING_PREVIEW_FRAGMENT on ListingData {
        branch {
            logoUrl
            name
            branchDetailsUri
            address
        }
        counts {
            numBathrooms
            numBedrooms
            numLivingRooms
        }
        displayAddress
        pricing {
            label
            priceQualifierLabel
        }
        propertyImage {
            filename
        }
        section
        statusSummary {
            label
        }
        title
    }
`;
